import { TextField } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  textfield: {
    width: ({ width }) => width || '321px',
    height: ({ height }) => height || '44px',
    padding: '12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
  },
});

const CustomTextField = ({
  id,
  name,
  handleChange,
  placeholder,
  value,
  rows,
  disabled,
  width,
  height,
  multiline,
  defaultValue,
}) => {
  const classes = useStyles({ width, height });

  return (
    <TextField
      id={id}
      fullWidth
      name={name}
      required
      autoComplete="off"
      multiline={multiline}
      autoSave="off"
      onChange={handleChange}
      placeholder={placeholder}
      defaultValue={defaultValue}
      InputProps={{
        disableUnderline: true,
        classes: {
          input: classes.textfield,
        },
      }}
      value={value}
      rows={rows}
      disabled={disabled || false}
    />
  );
};

export default React.memo(CustomTextField);
